<template>
    <cadastro-simples-form
        endpoint="modalidade"
        rota-base="/admin/modalidade"
        titulo-singular="Modalidade"
        :campos-extras='[{"campo":"descricao","label":"Descrição","tipo":"text","span":24},{"campo":"ordem","label":"Ordem","tipo":"int"}]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
